// extracted by mini-css-extract-plugin
var _1 = "AKCB4";
var _2 = "gWN1L";
export { _1 as "placesMoreButton", _2 as "placesMoreButtonMargin" }
